import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue';
import IconButton from './base/IconButton.vue';
import SwitchThemeIcon from './icons/SwitchThemeIcon.vue';
import { IconButtonLayout } from '../../constants/room';
import { useBasicStore } from '../../stores/basic';
import { useI18n } from '../../locales';
import { roomService } from '../../services';
interface Props {
  visible?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchTheme',
  props: {
    visible: { type: Boolean, default: true }
  },
  setup(__props: any) {

const basicStore = useBasicStore();
const { t } = useI18n();
const switchThemeConfig = roomService.getComponentConfig('SwitchTheme');



function handleSwitchTheme() {
  roomService.setTheme(basicStore.defaultTheme === 'white' ? 'black' : 'white');
}

return { __sfc: true,basicStore, t, switchThemeConfig, handleSwitchTheme, IconButton, SwitchThemeIcon, IconButtonLayout }
}

})